import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BRANDING_SETTINGS_QUERY_KEY = 'accountProfile/branding';

export function useBrandingSettingsQuery(
	params: { impersonationContext?: Api.IImpersonationContext; enabled?: boolean } = {}
) {
	const userSession = useUserSession();
	return useQuery<Api.BrandingSettings | null>({
		// An account with no brand settings answers 200 with no value; react-query rejects undefined data, so map it to null.
		queryFn: async () =>
			(await userSession.webServiceHelper.callAsync<Api.BrandingSettings>({
				path: Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'accountProfile/branding',
					impersonationContext: params.impersonationContext,
				}),
				method: 'GET',
				throwOn404: false,
			})) ?? null,
		queryKey: [BRANDING_SETTINGS_QUERY_KEY, params.impersonationContext],
		enabled: params.enabled ?? true,
		staleTime: 5 * 60 * 1000,
	});
}

// Invalidate on the base key: callers pass impersonationContext as null, undefined or an instance, and each is a distinct cache key.
export function invalidateBrandingSettingsQueries() {
	return reactQueryClient.invalidateQueries({ queryKey: [BRANDING_SETTINGS_QUERY_KEY] });
}
